import { createTriggerUtils, ITrigger, ITriggerJavaData, ITriggerWebConfig } from "@droid/project-v2-interface"
import { appTriggerNamespace } from "../app-namespace"
import { ulid } from "ulid"
import { UI } from "./UI"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, '[ITriggerWhenActivityIn]')
fileLog.pause = true
fileLog.childrenPaused = true

const type = `${appTriggerNamespace}when-activity-in`
fileLog.log('[ITriggerWhenActivityIn] type:', type)

export interface ITriggerWhenActivityInJavaData {
    pn: string
    an: string
    cn?: string
}

export interface ITriggerWhenActivityInWebConfig extends ITriggerWebConfig {
    // When Activity In Trigger 特有的 Web 配置
}

export interface ITriggerWhenActivityInData extends ITrigger<ITriggerWhenActivityInJavaData, ITriggerWhenActivityInWebConfig> {
}

function createDefaultData(): ITriggerWhenActivityInData {
    fileLog.log('[ITriggerWhenActivityIn.createDefaultData] 创建默认数据')
    const ulidValue = ulid()
    const data = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        javaData: {
            pn: "",
            an: "",
            cn: ""
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[ITriggerWhenActivityIn.createDefaultData] data:', JSON.stringify(data))
    return data
}

function init() {
    fileLog.log('[ITriggerWhenActivityIn.init] 初始化')
}

export const triggerWhenActivityInUtils = createTriggerUtils<ITriggerWhenActivityInData>(type, init, createDefaultData, UI)
